module.exports = __webpack_public_path__ + "img/ticket_ex1.ab9e748c.svg";